import { render } from "./MultiplePetsInput.vue?vue&type=template&id=34542b1b&scoped=true"
import script from "./MultiplePetsInput.vue?vue&type=script&lang=js"
export * from "./MultiplePetsInput.vue?vue&type=script&lang=js"

import "./MultiplePetsInput.vue?vue&type=style&index=0&id=34542b1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34542b1b"]])

export default __exports__